<div class="card profile-overview profile-overview-wide">
    <div class="card-body d-flex pb-1" *ngIf="userInfo">
      <!-- Profile picture / "Update cover photo" hidden for now
      <div class="clearfix">
        <div class="d-inline-block position-relative me-sm-4 me-3 mb-3 mb-lg-0">
          <label for="upload" class="c-pointer">
            <img [src]="userInfo?.profile_image" (error)="handleImageError($event)" alt="Owner Image" class="rounded-4 profile-avatar">
            <p class="glyphicon glyphicon-folder-open" aria-hidden="true">Update cover photo<i class="fa fa-edit ms-1"></i></p>
            <input type="file" id="upload" accept="image/*" class="display" (input)="updateCoverPhoto($event)">
          </label>
        </div>
      </div>
      -->
      <div class="clearfix d-xl-flex flex-grow-1">
        <div class="clearfix pe-md-5">
          <h3 class="fw-semibold mb-1"> {{userInfo.first_name}} {{userInfo.last_name}}
          </h3>
          <ul class="d-flex flex-wrap fs-6 align-items-center">
            <li class="me-3 d-inline-flex align-items-center">
              <i class="las la-phone me-1 fs-18"></i>{{userInfo.phone}}
            </li>            
            <li class="me-3 d-inline-flex align-items-center">
              <i class="las la-envelope me-1 fs-18"></i>{{userInfo.email}}
            </li>
          </ul>
          
        </div>       
      </div>
    </div>
    <div class="card-footer py-0 d-flex flex-wrap justify-content-between align-items-center px-0 mt-2">
      <ul class="nav nav-underline nav-underline-primary nav-underline-text-dark nav-underline-gap-x-0" id="tabMyProfileBottom" role="tablist">
        <li class="nav-item ms-1" role="presentation" *ngIf="checkUserInfoTab">
          <a [routerLink]="['/admin/owner-details/overview', userType , userId]" class="nav-link py-3 border-3 c-pointer text-dark" [ngClass]="{ 'active': currentUrl === '/admin/owner-details/overview/' + userType + '/' + userId }">Info</a>
        </li>
        <li class="nav-item ms-1" role="presentation" *ngIf="checkUserDocumentsTab">
          <a [routerLink]="['/admin/owner-details/documents', userType , userId]" class="nav-link py-3 border-3 c-pointer text-dark" [ngClass]="{ 'active': currentUrl === '/admin/owner-details/documents/' + userType + '/' + userId }">Documents</a>
        </li>
        <li class="nav-item ms-1" role="presentation" *ngIf="checkUserLeaseTab">
          <a [routerLink]="['/admin/owner-details/tax-info', userType , userId]" class="nav-link py-3 border-3 c-pointer text-dark" [ngClass]="{ 'active': currentUrl === '/admin/owner-details/tax-info/' + userType + '/' + userId }">Lease</a>
        </li>
        <li class="nav-item ms-1" role="presentation" *ngIf="checkUserBillsTab">
          <a [routerLink]="['/admin/owner-details/bills', userType , userId]" class="nav-link py-3 border-3 c-pointer text-dark" [ngClass]="{ 'active': currentUrl === '/admin/owner-details/bills/' + userType + '/' + userId }">Bills</a>
        </li>        
        <li class="nav-item ms-1" role="presentation" *ngIf="checkUserBankTab">
            <a [routerLink]="['/admin/owner-details/bank-details', userType , userId]" class="nav-link py-3 border-3 c-pointer text-dark" [ngClass]="{ 'active': currentUrl === '/admin/owner-details/bank-details/' + userType + '/' + userId }">Bank Account</a>
        </li>
        <li class="nav-item ms-1" role="presentation" *ngIf="checkUserLocalContactTab">
            <a [routerLink]="['/admin/owner-details/local-contact', userType , userId]" class="nav-link py-3 border-3 c-pointer text-dark" [ngClass]="{ 'active': currentUrl === '/admin/owner-details/local-contact/' + userType + '/' + userId }">Local Contact Person</a>
        </li>
        <li class="nav-item ms-1" role="presentation" *ngIf="checkUserInfoTab">
            <a [routerLink]="['/admin/owner-details/additional-info', userType , userId]" class="nav-link py-3 border-3 c-pointer text-dark" [ngClass]="{ 'active': currentUrl === '/admin/owner-details/additional-info/' + userType + '/' + userId }">Additional Info</a>
        </li>
        
      </ul>
      <ul class="d-md-flex d-none py-2 display">
        <li class="px-1">
          <a class="btn btn-light btn-sharp" href="javascript:void(0);">
            <i class="fa-brands fa-linkedin-in"></i>
          </a>
        </li>
        <li class="px-1">
          <a class="btn btn-light btn-sharp" href="javascript:void(0);">
            <i class="fa-brands fa-instagram"></i>
          </a>
        </li>
        <li class="px-1">
          <a class="btn btn-light btn-sharp" href="javascript:void(0);">
            <i class="fa-brands fa-facebook-f"></i>
          </a>
        </li>
        <li class="px-1">
          <a class="btn btn-light btn-sharp" href="javascript:void(0);">
            <i class="fa-brands fa-telegram"></i>
          </a>
        </li>
        <li class="px-1">
          <a class="btn btn-light btn-sharp" href="javascript:void(0);">
            <i class="fa-brands fa-youtube"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>